/* eslint-disable default-case */
import { useState, useEffect } from "react";

import {
  Box,
  IconButton,
  Typography,
  useTheme,
  Drawer,
  useMediaQuery,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  Menu as MenuIcon,
  BarChart as BarChartIcon,
  SettingsOutlined,
  AutorenewOutlined,
  AutoAwesome,
  ThumbUpAlt,
  LockOutlined,
  ReceiptLongOutlined,
  AttachMoneyRounded,
  HourglassEmptyOutlined,
  Public,
  SmartphoneOutlined,
  AccountBalanceWalletOutlined,
} from "@mui/icons-material";
import { tokens } from "../../theme";
import { alpha } from "@mui/material/styles";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarContent,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, useNavigate } from "react-router-dom";
import { companyManagementUrl } from "../../config";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { Groups2Outlined } from "@mui/icons-material";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import CasesIcon from "@mui/icons-material/Cases";
import WorkIcon from "@mui/icons-material/Work";
import AddchartIcon from "@mui/icons-material/Addchart";
import SummarizeIcon from "@mui/icons-material/Summarize";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import CheckIcon from "@mui/icons-material/Check";
import GavelIcon from "@mui/icons-material/Gavel";
import TerrainIcon from "@mui/icons-material/Terrain";
import MessageIcon from "@mui/icons-material/Message";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import AppsIcon from "@mui/icons-material/Apps";
import Axios from "axios";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FeedIcon from "@mui/icons-material/Feed";
import ApprovalIcon from "@mui/icons-material/Approval";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoneyIcon from "@mui/icons-material/Money";
import AddHomeIcon from "@mui/icons-material/AddHome";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PaymentIcon from "@mui/icons-material/Payment";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import GroupsIcon from "@mui/icons-material/Groups";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GradingIcon from "@mui/icons-material/Grading";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import BookmarkAddOutlinedIcon from "@mui/icons-material/BookmarkAddOutlined";
import BookmarkAddedOutlinedIcon from "@mui/icons-material/BookmarkAddedOutlined";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import MapIcon from "@mui/icons-material/Map";
import BackupTableIcon from "@mui/icons-material/BackupTable"; //docs
import FileOpenIcon from "@mui/icons-material/FileOpen"; //companyfiles
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate"; //terms
import PaymentsIcon from "@mui/icons-material/Payments";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import SpeedIcon from "@mui/icons-material/Speed";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";

function getIconByName(iconName) {
  switch (iconName) {
    case "home":
      return <HomeOutlinedIcon />;
    case "Product":
      return <ProductionQuantityLimitsIcon />;
    case "users":
      return <PeopleOutlinedIcon />;
    case "contacts":
      return <ContactsOutlinedIcon />;
    case "receipt":
      return <ReceiptOutlinedIcon />;
    case "Client":
      return <PersonIcon />;
    case "diaries":
      return <CalendarTodayOutlinedIcon />;
    case "help":
      return <HelpOutlinedIcon />;
    case "barChart":
      return <BarChartOutlinedIcon />;
    case "pieChart":
      return <PieChartOutlinedIcon />;
    case "timeline":
      return <TimelineOutlinedIcon />;
    case "menu":
      return <MenuOutlinedIcon />;
    case "map":
      return <MapOutlinedIcon />;
    case "analytics":
      return <AnalyticsOutlinedIcon />;
    case "Accounts":
      return <ManageAccountsIcon />;
    case "Dashboard":
      return <DashboardIcon />;
    case "clients":
      return <GroupIcon />;
    case "Cases":
      return <WorkIcon />;
    case "diaries":
      return <MenuBookIcon />;
    case "adhoc":
      return <AccountTreeIcon />;
    case "chartofAccounta":
      return <AddchartIcon />;
    case "reports":
      return <SummarizeIcon />;
    case "companies":
      return <LocationCityIcon />;
    case "module":
      return <ViewModuleIcon />;
    case "role":
      return <SettingsApplicationsIcon />;
    case "rolegroup":
      return <AddTaskIcon />;
    case "rights":
      return <CheckIcon />;
    case "subright":
      return <AppsIcon />;
    // setup Management
    case "Court Setup-icon":
      return <GavelIcon />;
    case "Geography-icon":
      return <TerrainIcon />;
    case "Message-icon":
      return <MessageIcon />;
    case "othersetups":
      return <SettingsApplicationsIcon />;
    case "Lead-icon":
      return <ViewModuleIcon />;
    case "systemsetups":
      return <SettingsSuggestIcon />;
    case "module":
      return <ViewModuleIcon />;
    case "leave Approvals":
      return <CheckCircleIcon />;
    case "leave applications":
      return <ApprovalIcon />;
    case "pos-setups":
      return <SettingsApplicationsIcon />;
    case "imprestApprovals":
      return <CheckCircleIcon />;
    case "my imprest applications":
      return <MoneyIcon />;
    case "Staff Claim Approvals":
      return <CreditScoreIcon />;
    case "mystaffclaims":
      return <PaymentIcon />;
    case "expenses":
      return <PaymentIcon />;
    case "Imprest Surrender":
      return <LocalOfferIcon />;
    case "PettyCash":
      return <MoneyIcon />;
    case "PointOfSale":
      return <PointOfSaleOutlinedIcon />;
    case "customer":
      return <GroupIcon />;
    case "groups":
      return <Diversity3Icon />;
    case "suspendedtransactions":
      return <QuizOutlinedIcon />;
       case "commission":
      return <QuizOutlinedIcon />;
       case "pulltransactions":
      return <CloudDownloadOutlinedIcon />;
    case "manualrecon":
      return <UploadFileOutlinedIcon />;
    case "accounttransfers":
      return <CurrencyExchangeIcon />;
    case "processauthorization":
      return <VerifiedUserIcon />;
    case "manageaccounttransfers":
      return <GradingIcon />;
    case "loanrebooking":
      return <PublishedWithChangesIcon />;
    case "customermigration":
      return <PersonRemoveIcon />;
    case "rescheduleloan":
      return <PendingActionsIcon />;
    case "groupmigration":
      return <GroupRemoveIcon />;
    case "loanschedule":
      return <PendingActionsIcon />;
    case "sababisha":
      return <PublishedWithChangesIcon />;
    case "loanrebooking":
      return <AutorenewOutlined />;
    case "Recon":
      return <AutoAwesome />;
    case "rescheduleloan":
      return <CalendarTodayOutlinedIcon />;
    case "approval":
      return <BookmarkAddedOutlinedIcon />;
    case "bookloan":
      return <BookmarkAddOutlinedIcon />;
    case "maps":
      return <MapIcon />;
    case "terms":
      return <AssignmentLateIcon />;
    case "files":
      return <FileOpenIcon />;
    case "docs":
      return <BackupTableIcon />;
    case "payment360":
      return <PaymentsIcon />;
    case "decline":
      return <ThumbDownAltIcon />;
    case "sms":
      return <MarkUnreadChatAltIcon />;
    case "hr setups":
      return <SettingsSuggestIcon />;
    case "device setups":
    case "devicesetups":
    case "devicelocksetups":
    case "device registry":
    case "deviceregistry":
    case "devices":
      return <SmartphoneOutlined />;
    case "wallet":
    case "companywallet":
    case "walletmanagement":
    case "sgwapprovals":
    case "sgw-approvals":
    case "sgw approvals":
      return <AccountBalanceWalletOutlined />;

    //modules
    case "setupmanagement":
      return <SettingsApplicationsIcon />;
    case "user management":
      return <PersonIcon />;
    case "role management":
      return <AddTaskIcon />;
    case "accountsandfinancemanagement":
      return <ManageAccountsIcon />;
    case "clientmanagement":
      return <GroupIcon />;
    case "casemanagement":
      return <WorkIcon />;
    case "companymanagement":
      return <LocationCityIcon />;
    case "dashboard":
      return <DashboardIcon />;
    case "hrmanagement":
      return <FeedIcon />;
    case "customers":
      return <GroupsIcon />;
    case "settings":
      return <SettingsOutlined />;
    case "customerapprove":
      return <ThumbUpAlt />;
    case "collateral":
      return <LockOutlined />;
    case "perfomance":
      return <SpeedIcon />;
    case "penalty":
      return <ReceiptLongOutlined />;
    case "loanpenalty":
      return <AttachMoneyRounded />;
    case "group-penalty":
      return <AttachMoneyRounded />;
    case "approveloanpenalty":
      return <HourglassEmptyOutlined />;
    case "grouppenalty":
      return <ReceiptLongOutlined />;
    case "migrateregion":
      return <Public />;
    case "Announcement-icon":
      return <CampaignOutlinedIcon />;
    case "sababishaadmin":
      return <SettingsSuggestIcon />;
  }
}

const Item = ({
  title,
  to,
  icon,
  selected,
  setSelected,
  setMenuSelected,
  selectedMenu,
  submenuitems,
  isCollapsed,
  forceOpen = false,
  onClick,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Local open state only used when not searching
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = () => {
    setMenuSelected(title);
    setIsOpen((prev) => !prev);
  };

  const shouldBeOpen = forceOpen || isOpen;
  const isDark = theme.palette.mode === "dark";
  const activeColor = colors.primary[500];

  return (
    <SubMenu
      open={shouldBeOpen}
      active={selectedMenu === title}
      style={{
        color: selectedMenu === title ? activeColor : colors.grey[200],
        fontWeight: selectedMenu === title ? 700 : 500,
      }}
      icon={
        <Tooltip
          title={isCollapsed ? title : ""}
          placement="right"
          arrow
        >
          <Box
            sx={{
              display: "flex",
              color: selectedMenu === title ? activeColor : "inherit",
            }}
          >
            {getIconByName(icon)}
          </Box>
        </Tooltip>
      }
      title={title}
      to={to}
      onOpenChange={handleOpenChange}
    >
      {(submenuitems || []).map((submenuitem, j) => {
        const isActiveSub = selected === submenuitem.title;
        return (
          <Tooltip
            key={j}
            title={isCollapsed ? submenuitem.title : ""}
            placement="right"
            arrow
          >
            <MenuItem
              active={isActiveSub}
              style={{
                color: isActiveSub ? activeColor : colors.grey[200],
                fontWeight: isActiveSub ? 700 : 500,
                borderLeft: `3px solid ${isActiveSub ? activeColor : "transparent"}`,
                backgroundColor: isActiveSub
                  ? alpha(activeColor, isDark ? 0.22 : 0.1)
                  : "transparent",
              }}
              onClick={() => {
                setSelected(submenuitem.to);
                setMenuSelected(title);
                localStorage.setItem("RightIdFromSidebar", submenuitem.id);
                localStorage.setItem("SelectedRight", submenuitem.title);
                if (onClick) onClick();
              }}
              icon={
                <Box sx={{ display: "flex", color: isActiveSub ? activeColor : "inherit" }}>
                  {getIconByName(submenuitem.icon)}
                </Box>
              }
              to={submenuitem.to}
            >
              <Link
                to={submenuitem.to}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                {submenuitem.title}
              </Link>
            </MenuItem>
          </Tooltip>
        );
      })}
    </SubMenu>
  );
};


const Sidebar = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("Dashboard");
  const [selectedMenu, setMenuSelected] = useState("Dashboard");
  const [apiData, setData] = useState([]);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isButtonVisible, setButtonVisible] = useState(true);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openMenus, setOpenMenus] = useState([]);

  const getDecodedToken = () => {
    try {
      return JSON.parse(localStorage.getItem("decodedToken"));
    } catch (e) {
      return null;
    }
  };

  const getLogoPath = () => {
    const storedFilePath = localStorage.getItem("filePath");
    const cachedLocal = localStorage.getItem("uploadedLogoDataUrl");

    if (!storedFilePath || storedFilePath === "null" || storedFilePath === "undefined") {
      return cachedLocal || `/SSLLOGO.jpg`;
    }
    if (
      storedFilePath.startsWith("http://") ||
      storedFilePath.startsWith("https://") ||
      storedFilePath.startsWith("data:")
    ) {
      return storedFilePath;
    }
    if (storedFilePath === "/SSLLOGO.jpg" || storedFilePath === "SSLLOGO.jpg") {
      return cachedLocal || "/SSLLOGO.jpg";
    }
    const apiBase = companyManagementUrl?.upload_logo_uri
      ? companyManagementUrl.upload_logo_uri.replace(/\/company\/uploadlogo.*/i, "")
      : "";
    const cleanPath = storedFilePath.startsWith("/") ? storedFilePath : `/${storedFilePath}`;
    return apiBase ? `${apiBase}${cleanPath}` : cleanPath;
  };

  const decodedTokenData = getDecodedToken();
  const companyName = decodedTokenData?.Company;
  const cachedTagLine = decodedTokenData?.TagLine;

  const [filePath, setFilePath] = useState(getLogoPath);

  // Listen for logo updates dispatched by the upload form (same-tab)
  useEffect(() => {
    const handleLogoUpdated = () => {
      setFilePath(getLogoPath());
    };
    window.addEventListener("logo-updated", handleLogoUpdated);
    return () => window.removeEventListener("logo-updated", handleLogoUpdated);
  }, []);

  useEffect(() => {
    const rights = JSON.parse(localStorage.getItem("rights"));
    if (!rights) {
      // Remove only auth keys — logo keys must NOT be cleared here.
      ["token", "tokenExpiration", "decodedToken", "rights", "rightsforrbac", "systemAToken"]
        .forEach((k) => localStorage.removeItem(k));
      navigate("/login");
    }
    const cleanedData = rights ? JSON.parse(rights.replace(/\\/g, "")) : null;

    if (cleanedData && Array.isArray(cleanedData)) {
      const setupMgmt = cleanedData.find(
        (m) => m.title?.toLowerCase().replace(/\s/g, "") === "setupmanagement"
      );
      if (setupMgmt) {
        const hasDeviceSetups = (setupMgmt.children || []).some(
          (c) =>
            c.title?.toLowerCase().replace(/\s/g, "") === "devicesetups" ||
            c.title?.toLowerCase().replace(/\s/g, "") === "devicelocksetups"
        );
        if (!hasDeviceSetups) {
          const deviceSetupsSubmodule = {
            id: 9920,
            title: "Device Setups",
            to: "/device-setups",
            icon: "devicesetups",
            subrights: [
              { id: 9922, title: "Device Lock Policies" },
              { id: 9923, title: "Device Lock Actions" },
            ],
          };
          const afsIndex = (setupMgmt.children || []).findIndex(
            (c) => c.title?.toLowerCase().replace(/\s/g, "") === "assetfinancesetups"
          );
          if (afsIndex !== -1) {
            setupMgmt.children.splice(afsIndex + 1, 0, deviceSetupsSubmodule);
          } else {
            setupMgmt.children.push(deviceSetupsSubmodule);
          }
        }
      }

      const walletMgmt = cleanedData.find(
        (m) =>
          m.title?.toLowerCase().replace(/\s/g, "") === "walletmanagement" ||
          m.title?.toLowerCase().replace(/\s/g, "") === "wallet" ||
          m.title?.toLowerCase().replace(/\s/g, "") === "companywallet"
      );
      if (walletMgmt) {
        const hasSgwApprovals = (walletMgmt.children || []).some(
          (c) =>
            c.title?.toLowerCase().replace(/\s/g, "") === "sgwapprovals" ||
            c.to === "/sgw-approvals"
        );
        if (!hasSgwApprovals) {
          const sgwApprovalsSubmodule = {
            id: 9940,
            title: "SGW Approvals",
            to: "/sgw-approvals",
            icon: "sgwapprovals",
            subrights: [
              { id: 9941, title: "SGW Approvals Setup" },
            ],
          };
          walletMgmt.children = walletMgmt.children || [];
          walletMgmt.children.push(sgwApprovalsSubmodule);
        }
      }
    }

    setData(cleanedData);

    //restore sidebar state from local storage
    const savedMenuState = localStorage.getItem("selectedMenu");
    const savedSubMenuState = localStorage.getItem("selected");
    if (savedMenuState) setMenuSelected(savedMenuState);
    if (savedSubMenuState) setSelected(savedSubMenuState);
  }, []);
  useEffect(() => {
    if (isSmallScreen) {
      setDrawerOpen(false);
    }
  }, [selected]); // Close the sidebar when a menu item is selected

  //save sidebar state to local storage
  useEffect(() => {
    localStorage.setItem("selectedMenu", selectedMenu);
    localStorage.setItem("selected", selected);
  }, [selectedMenu, selected]);
  // const desiredOrder = [
  //   "Dashboard",
  //   "Company Management",
  //   "Accounts and Finance",
  //   "User Management",
  //   "Customer Management",
  //   "Loan Management",
  //   "Group Loan Management",
  //   "Role Management",
  //   "Report Management",
  //   "Expense Management",
  //   "Setup Management",
  //   "Document Manager",
  // ];

  // // Sort apiData based on desiredOrder
  // const sortedData = apiData.sort((a, b) => {
  //   const indexA = desiredOrder.indexOf(a.title);
  //   const indexB = desiredOrder.indexOf(b.title);
  //   return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  // });

   const sortedData = apiData;

  const filteredData = sortedData
    .map((menuitem) => {
      if (!searchTerm) return menuitem;

      const titleMatch = menuitem.title
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      const filteredChildren = (menuitem.children || []).filter((child) =>
        child.title.toLowerCase().includes(searchTerm.toLowerCase())
      );

      if (titleMatch || filteredChildren.length > 0) {
        return {
          ...menuitem,
          children: titleMatch ? menuitem.children : filteredChildren,
        };
      }

      return null;
    })
    .filter(Boolean);
useEffect(() => {
    if (!searchTerm) {
      setOpenMenus([]);
      return;
    }

    const matchedMenus = sortedData
      .map((menuitem) => {
        const titleMatch = menuitem.title
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

        const childMatch = (menuitem.children || []).some((child) =>
          child.title.toLowerCase().includes(searchTerm.toLowerCase())
        );

        return titleMatch || childMatch ? menuitem.title : null;
      })
      .filter(Boolean);

    setOpenMenus(matchedMenus);
  }, [searchTerm, apiData]); // was: [searchTerm, sortedData]
  const isDark = theme.palette.mode === "dark";
  const activeColor = colors.primary[500];
  const railBorder = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
  const hoverTint = alpha(activeColor, isDark ? 0.16 : 0.08);
  const activeTint = alpha(activeColor, isDark ? 0.24 : 0.12);

  const sidebarContent = (
    <Box
      sx={{
        height: "100vh",
        maxHeight: "100vh",
        position: "sticky",
        top: 0,
        left: 0,
        alignSelf: "flex-start",
        borderRight: `1px solid ${railBorder}`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        overscrollBehavior: "contain",
        "& .pro-sidebar, & .pro-sidebar-inner": {
          height: "100% !important",
        },
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-sidebar-layout": {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        "& .pro-sidebar-header": {
          flexShrink: 0,
          borderBottom: `1px solid ${railBorder}`,
        },
        "& .pro-sidebar-content": {
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          overscrollBehavior: "contain",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)",
            borderRadius: "3px",
          },
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
        },
        "& .pro-sidebar:not(.collapsed)": {
          width: "300px !important",
          minWidth: "300px !important",
        },
        "& .pro-menu .pro-menu-item": {
          fontSize: "0.95rem !important",
          margin: "4px 8px",
        },
        "& .pro-menu .pro-menu-item > .pro-inner-item": {
          padding: "12px 16px !important",
          borderRadius: "8px",
          color: `${colors.grey[100]} !important`,
          transition: "background-color 0.15s ease, color 0.15s ease",
        },
        "& .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper": {
          width: "32px !important",
          minWidth: "32px !important",
          height: "32px !important",
          lineHeight: "32px !important",
        },
        "& .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content": {
          whiteSpace: "normal !important",
          overflow: "visible !important",
          textOverflow: "clip !important",
          lineHeight: 1.3,
        },
        "& .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item": {
          padding: "10px 16px 10px 22px !important",
        },
        "& .pro-menu .pro-menu-item > .pro-inner-item:hover": {
          backgroundColor: `${hoverTint} !important`,
          color: `${activeColor} !important`,
        },
        "& .pro-menu .pro-menu-item.active > .pro-inner-item": {
          backgroundColor: `${activeTint} !important`,
          color: `${activeColor} !important`,
          fontWeight: "700 !important",
        },
        "& .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before": {
          background: `${colors.grey[400]} !important`,
        },
        "& .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow": {
          borderColor: `${colors.grey[300]} !important`,
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <SidebarHeader>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isCollapsed ? "center" : "space-between",
              gap: 1,
              px: isCollapsed ? 0 : 2,
              py: 2,
            }}
          >
            {!isCollapsed && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                <Box
                  component="img"
                  alt="company logo"
                  src={filePath}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    const cachedLocal = localStorage.getItem("uploadedLogoDataUrl");
                    if (cachedLocal && e.currentTarget.src !== cachedLocal) {
                      e.currentTarget.src = cachedLocal;
                    } else {
                      e.currentTarget.src = "/SSLLOGO.jpg";
                    }
                  }}
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "10px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={700}
                    color={colors.grey[100]}
                    noWrap
                  >
                    {companyName}
                  </Typography>
                  {cachedTagLine && (
                    <Typography
                      variant="caption"
                      fontStyle="italic"
                      color={colors.redAccent[400]}
                      noWrap
                      sx={{ display: "block" }}
                    >
                      {cachedTagLine}
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
            <IconButton
              onClick={() => setIsCollapsed(!isCollapsed)}
              size="small"
              sx={{
                color: colors.grey[200],
                bgcolor: alpha(activeColor, isDark ? 0.14 : 0.08),
                "&:hover": { bgcolor: hoverTint, color: activeColor },
              }}
            >
              {isCollapsed ? (
                <MenuOutlinedIcon fontSize="small" />
              ) : (
                <ChevronLeftIcon fontSize="small" />
              )}
            </IconButton>
          </Box>

          {!isCollapsed && (
            <Box px={2} pb={2}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search menu..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon sx={{ fontSize: 18, color: colors.grey[300] }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: "10px",
                    bgcolor: isDark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.7)",
                    color: colors.grey[100],
                    fontSize: "0.85rem",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: railBorder },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: alpha(activeColor, 0.5),
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: activeColor,
                    },
                  },
                }}
              />
            </Box>
          )}
        </SidebarHeader>

        <SidebarContent>
          <Menu iconShape="square">
            <Box paddingLeft={isCollapsed ? undefined : "1px"}>
              {filteredData.map((menuitem, i) => (
                <Item
                  key={i}
                  title={menuitem.title}
                  icon={menuitem.icon}
                  selected={selected}
                  setSelected={setSelected}
                  setMenuSelected={setMenuSelected}
                  selectedMenu={selectedMenu}
                  submenuitems={menuitem.children}
                  isCollapsed={isCollapsed}
                  forceOpen={openMenus.includes(menuitem.title)}
                  onClick={() => {
                    if (isSmallScreen) {
                      setDrawerOpen(false);
                    }
                  }}
                />
              ))}
            </Box>
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </Box>
  );
  return (
    <Box sx={{ height: "100%", maxHeight: "100vh", overflow: "hidden" }}>
      {isSmallScreen ? (
        <>
          {/* Menu button only when sidebar is closed */}
          {!isDrawerOpen && (
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{
                position: "fixed",
                top: 16,
                left: 16,
                zIndex: 1300,
                bgcolor: colors.primary[500],
                color: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                "&:hover": { bgcolor: colors.primary[500], opacity: 0.9 },
              }}
            >
              <MenuOutlinedIcon />
            </IconButton>
          )}

          <Drawer
            anchor="left"
            open={isDrawerOpen}
            onClose={() => {
              setDrawerOpen(false);
              setButtonVisible(true);
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {sidebarContent}
          </Drawer>
        </>
      ) : (
        sidebarContent
      )}
    </Box>
  );
};

export default Sidebar;
